import React, { createContext, useState, useContext, useEffect } from "react";
import { useSnackbar } from "notistack";

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  console.log(user);

  // 🔹 Load user from localStorage
  useEffect(() => {
    try {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }
    } catch (err) {
      console.error("Error loading user:", err);
      enqueueSnackbar("Failed to load user session", { variant: "error" });
    } finally {
      setLoading(false);
    }
  }, [enqueueSnackbar]);

  // ✅ hasRole: true if user’s role or permission matches, or if Admin/SuperAdmin
  const hasRole = (role) => {
    if (!user) return false;
    if (user.superadmin) return true;
    return user.role === role || user.permissions?.includes(role);
  };

  // ✅ hasAnyRole: true if any of roles/permissions match, or if Admin/SuperAdmin
  const hasAnyRole = (roles = []) => {
    if (!user) return false;
    if (user.superadmin) return true;

    const roleMatch = roles.includes(user.role);
    const permissionMatch = user.permissions?.some((perm) =>
      roles.includes(perm)
    );

    return roleMatch || permissionMatch;
  };

  const value = {
    user,
    loading,
    isAuthenticated: !!user,
    hasRole,
    hasAnyRole,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
